<section class="playground">
  <h2 class="playground__heading">Checkbox</h2>
  <p class="playground__hint">
    <code>app-common-checkbox</code> — variante <code>type</code> + estados (<code>checked</code>,
    <code>indeterminate</code>, <code>disabled</code>).
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>type</span>
        <select [(ngModel)]="type">
          <option *ngFor="let t of types" [value]="t">{{ t }}</option>
        </select>
      </label>

      <label class="playground__field">
        <span>labelKey (i18n)</span>
        <input type="text" [(ngModel)]="labelKey" placeholder="Ej. uiKitExamples...." />
      </label>

      <label class="playground__field">
        <span>labelPosition</span>
        <select [(ngModel)]="labelPosition">
          <option *ngFor="let p of positions" [value]="p">{{ p }}</option>
        </select>
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [checked]="control.value" (change)="toggleValue()" />
        <span>checked</span>
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="indeterminate" />
        <span>indeterminate</span>
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="disabled" />
        <span>disabled</span>
      </label>

      <label class="playground__field">
        <span>customClass (debug)</span>
        <input type="text" [(ngModel)]="customClass" placeholder="Ej. full-width center" />
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview</p>
      <div class="playground__preview-box">
        <app-common-checkbox
          [type]="type"
          [labelKey]="labelKey"
          [labelPosition]="labelPosition"
          [indeterminate]="indeterminate"
          [disabled]="disabled"
          [customClass]="customClass"
          [formControl]="control"
          (change)="onChange($event)"
        ></app-common-checkbox>
      </div>

      <p class="playground__meta">
        Valor FormControl: <strong>{{ control.value }}</strong>
      </p>
      <p *ngIf="lastEvent" class="playground__meta">{{ lastEvent }}</p>
    </div>
  </div>
</section>

